export default "__VITE_ASSET__3c337561__"